import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

// Initialize i18next
i18n
  .use(HttpApi) // Load translations from backend
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["ar", "en"],
    fallbackLng: "ar", // Set Arabic as the default language
    react: {
      useSuspense: false,
    },
    detection: {
      order: ["querystring", "localStorage"],
      caches: ["localStorage"],
    },
  });

export default i18n;
